export default __webpack_public_path__ + "static/media/intiazlizeProducts.29d71bd6.jpg";